module.exports = __webpack_public_path__ + "img/skull_4.8c95fc96.png";